import { render, staticRenderFns } from "./brand-details.vue?vue&type=template&id=08d01b94&"
import script from "./brand-details.vue?vue&type=script&lang=js&"
export * from "./brand-details.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports